"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createReduxForm = _interopRequireDefault(require("./createReduxForm"));

var _plain = _interopRequireDefault(require("./structure/plain"));

var _default = (0, _createReduxForm["default"])(_plain["default"]);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/reduxForm.js
// module id = 903
// module chunks = 0